import { useLocation } from "react-router-dom";
import GenerateWebsitePageV4 from "./GenerateWebsitePageV4";
import GenerateWebsitePage from "./GenerateWebsitePage";

export default function GenerateWebsitePageRouter() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const engine = params.get("engine") || "v1";

    if (engine.toLowerCase() === "v2") {
        return <GenerateWebsitePageV4 />;
    }

    return <GenerateWebsitePage />;
}